// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VRvvS{color:var(--sui-color-red)}._bpPb{color:var(--anchore-color-gray-500)}.OlWyu.ui.bottom.right.popup:before,.OlWyu.ui.top.right.popup:before{right:.35em}.OlWyu.ui.bottom.left.popup:before,.OlWyu.ui.top.left.popup:before{left:.35em}.OlWyu.ui.popup .content{padding-top:0}.OlWyu p{font-size:.9rem;margin-bottom:.5em}.OlWyu p:last-child{margin-bottom:0}.OlWyu .ui.popup h4,.OlWyu h4{font-size:1.1rem;font-weight:700;margin:.25rem 0}.OlWyu .ui.popup h4:first-child,.OlWyu h4:first-child{margin-top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kevIcon": `VRvvS`,
	"notKevIcon": `_bpPb`,
	"popup": `OlWyu`
};
module.exports = ___CSS_LOADER_EXPORT___;
